import React from 'react';
import CustomerForm from '../../components/CustomerForm';

const AddCustomer: React.FC = () => {
  return <CustomerForm />;
};

export default AddCustomer;
